import { DATATEST } from "constants/integration";
export const NONE = "None";
export const SHOW_COLOR_SWATCH = "showColorSwatch";
export const SHOW_UNITS = "showUnits";
export const SHOW_DOORS = "showDoors";
export const SHOW_TOTAL_COST = "showTotalCost";
export const SHOW_TOTAL_RETAIL = "showTotalRetail";
export const SHOW_COST = "showCost";
export const SHOW_RETAIL = "showRetail";
export const SHOW_EACHES_ON_HOVER = "showEachesOnHover";
export const KINDS_TO_ALLOW = ["DEFAULT_KIND", "FORMULA", "BRAND_NAME"];
export const DEFAULT_VIEW_SETTINGS = "defaultTileSettings";
export const CUSTOM_VIEW_SETTINGS = "customTileSettings";
export const TILE_LINE_SETTINGS = [
    {
        label: "First Line",
        name: "firstLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.FIRST_LINE,
    },
    {
        label: "Second Line",
        name: "secondLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.SECOND_LINE,
    },
    {
        label: "Third Line",
        name: "thirdLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.THIRD_LINE,
    },
    {
        label: "Fourth Line",
        name: "fourthLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.FOURTH_LINE,
    },
    {
        label: "Fifth Line",
        name: "fifthLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.FIFTH_LINE,
    },
    {
        label: "Sixth Line",
        name: "sixthLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.SIXTH_LINE,
    },
    {
        label: "Seventh Line",
        name: "seventhLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.SEVENTH_LINE,
    },
    {
        label: "Eighth Line",
        name: "eighthLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.EIGHTH_LINE,
    },
];
export const SHOP_TILE_LINE_SETTINGS = [
    {
        label: "First Line",
        name: "firstLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.FIRST_LINE,
    },
    {
        label: "Second Line",
        name: "secondLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.SECOND_LINE,
    },
    {
        label: "Third Line",
        name: "thirdLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.THIRD_LINE,
    },
    {
        label: "Fourth Line",
        name: "fourthLine",
        dataTest: DATATEST.ASSORTMENTS.TILE.SETTINGS.MODAL.FORM.FOURTH_LINE,
    },
];
